import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';
import slide1Img from '../../assets/slide1.jpg';
import slide2Img from '../../assets/slide2.jpg';
import slide3Img from '../../assets/slide3.jpg'; // Carefull, this one's a PNG
import Link from 'react-router-dom/Link';

export class ForDevelopersPage extends Component {
  render() {
    return (
      <div className="container">
        <Card>
          <Card.Header as="h3">
            Softie Pals for <i>Developers</i>
          </Card.Header>
          <Card.Body>
            Being a small, indie developer can be tough, we know. After finally
            spending all that time on developing and releasing your product or your
            awesome game, it is oftentimes really difficult to get users to find you.
            <br />
            You know your game is great... it's just that nobody can seem to find it.
          </Card.Body>
          <Card.Body>
            Some of the many problems that devs face after launch are:
            <ul>
              <li>
                {' '}
                Getting found in the first place by users that would genuinely
                like to use your product{' '}
              </li>
              <li>
                {' '}
                Acquiring a visible place on search result. Whether on Google or
                on an app store's searh, SEO to reach the top can be expensive.
              </li>
              <li>
                {' '}
                Finding the right users that really would like your product:
                paid marketing to reach these users can be something that is
                just too expensive.{' '}
              </li>
              <li>
                {' '}
                Getting useful feedback from these users: we're all tired of
                those "1 star this sucks" reviews that have no meaning at all{' '}
              </li>
              <li>
                {' '}
                Being able to answer the questions users may have{' '}
                <i>yourself</i> on a common platform{' '}
              </li>
            </ul>
          </Card.Body>

          <Card.Body>
            <h5>
              <i>That's where Softie Pals comes in for developers</i>
            </h5>
            There are users out there that would really want to try your
            product, but just can not find it under all the accumulated rubble
            in the internet. By giving devs the ability to create dedicated page
            for their software products and defining a custom category (what the
            product does), we aim to fix just that by uniting both users and
            developers on this common platform.
          </Card.Body>
        </Card>
        <br />
        <Carousel
          style={{
            padding: '20px',
          }}
        >
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={slide1Img}
              height="600px"
              alt="First slide"
            />
            <Carousel.Caption>
              <h3>Simple searching</h3>
              <p>
                Each product defines its custom category of what it does. Thus,
                you can easily find all the products that match what you want
                them to do!{' '}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={slide2Img}
              height="600px"
              alt="Second slide"
            />

            <Carousel.Caption style={{ color: '#000000' }}>
              <h3>Strong Review System</h3>
              <p>
                Browse reviews created in our innovative objective+subjective
                system: the review scores are generated based on objective
                parameters to provide you an accurate assesment of the product!{' '}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={slide3Img}
              height="600px"
              alt="Third slide"
            />
            <Carousel.Caption>
              <h3>QA: Question and Answer</h3>
              <p>
                Got a question? Know an answer? Post on each product's dedicated
                QA page!{' '}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        <br />
        <Jumbotron>
          <h1>Sounds exciting?</h1>
          <p>
            As part of our commitment to serving the community and making the
            platform open to everyone, the platform is free to use for everyone!
          </p>
          <p>
            <Button variant="outline-primary">
              <Link to="/signup">Get started now</Link>
            </Button>
          </p>
        </Jumbotron>
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default ForDevelopersPage;
